import {apiAxios} from "@/service/APIClient";
import LeagueDTO from "@/models/LeagueDTO";

export const leagues = {
    list: async (): Promise<LeagueDTO[]> => {
        let resp = await apiAxios({
            url: `/leagues`,
            method: 'GET',
        })

        return resp.data as LeagueDTO[]
    },
}
